import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {EventService} from "../../services/event.service";
import {SpotfightEvent} from "../../core/models/models";
import {EventCardComponent} from "../event-card/event-card.component";

import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {ImageService} from "../../services/image.service";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {isLongTermEvent} from "../../core/models/leagues";

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [
    EventCardComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule
],
  templateUrl: './events.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './events.component.scss'
})
export class EventsComponent implements OnInit {
  protected events: SpotfightEvent[] = []
  protected normalEvents: SpotfightEvent[] = []
  protected longTermEvents: SpotfightEvent[] = []
  protected filteredEvents: SpotfightEvent[] = []
  protected longTermExpanded = false;

  loading: boolean = true;

  sortAscending: boolean = false;
  leagueControl = new FormControl("league-filter")

  constructor(private eventService: EventService,
              private imageService: ImageService) {

  }

  ngOnInit(): void {
    this.leagueControl.setValue("ALL");
    this.leagueControl.valueChanges.subscribe(selectedLeague => {
      this.filterEvents(selectedLeague!);
    });

    this.loading = true;
    let imagePromises: Promise<void>[] = [];

    this.eventService.getAllEvents()
      .then((events) => {
        this.events = events;
        for (let event of events) {
          if (event.image_uri !== undefined && event.image_uri !== "") {
           let imagePromise =  this.imageService.getImage(event.image_uri)
              .then((value) => {
                event.image_content = value;
              })
              .catch(() => console.log("Error loading image for event"));
            imagePromises.push(imagePromise);
          }
        }
        this.events.sort((a, b) => {
          if (this.sortAscending) {
            return new Date(a.deadline).getTime() - new Date(b.deadline).getTime();
          }
          return new Date(b.deadline).getTime() - new Date(a.deadline).getTime();
        });
        this.longTermEvents = this.events.filter(isLongTermEvent);
        this.normalEvents = this.events.filter(event => !isLongTermEvent(event));
        this.filterEvents(this.leagueControl.value!);
        return Promise.all(imagePromises);
      })
      .catch()
      .finally(() => this.loading = false);
  }

  filterEvents(league: string): void {
    if (league === 'ALL') {
      this.filteredEvents = this.normalEvents; // No filter, show all regular league events
    } else {
      this.filteredEvents = this.normalEvents.filter(event => event.league === league);
    }
  }

  toggleLongTermEvents(): void {
    this.longTermExpanded = !this.longTermExpanded;
  }
}
